import { Link } from 'react-router-dom';
import I18n from 'i18n-js';

import { fetchCountryIfNeeded } from '@lootboy/lib/actions/CountryActions';
import useFetchSelector from '@lootboy/lib/hooks/useFetchSelector';

import AppBadges from '~/components/AppBadges';
import NewTabOpener from '~/components/NewTabOpener';

import { useSocialMedia } from '~/redux/hooks/useSocialMedia';
import { geoCountryPlainSelector } from '~/redux/selectors';
import {
  LEGAL_PATH,
  PRIVACY_POLICY_PATH,
  TERMS_PATH,
  VERSION_PATH,
  WITHDRAWAL_PATH,
} from '~/routes/paths';

import GameDeSection from './GameDeSection';

import style from './Footer.module.scss';

export default function Footer(): JSX.Element {
  const socialMedia = useSocialMedia();
  const { value: geoCountry } = useFetchSelector(
    fetchCountryIfNeeded,
    geoCountryPlainSelector,
  );

  return (
    <footer className={style.container}>
      <div className={style.top}>
        <AppBadges className={style.badges} />
        <GameDeSection className={style.gameDe} />
        {socialMedia && (
          <div className={style.socialMediaButtons}>
            {socialMedia.map(({ url, Icon, label }) => {
              if (!url || !Icon) {
                return null;
              }

              return (
                <NewTabOpener
                  key={label}
                  href={url}
                >
                  <Icon className={style.socialIcon} />
                </NewTabOpener>
              );
            })}
          </div>
        )}
      </div>
      <div className={style.bottom}>
        <p className={style.copyright}>
          {I18n.t('web_footer_copyright', { year: new Date().getFullYear() })}
        </p>
        <div className={style.links}>
          {geoCountry === 'DE' && (
            <NewTabOpener
              href="https://lootboygmbh.recruitee.com/"
              className={style.link}
            >
              {I18n.t('Footer_label_jobs')}
            </NewTabOpener>
          )}
          <Link
            to={LEGAL_PATH}
            className={style.link}
          >
            {I18n.t('Footer_label_legal')}
          </Link>
          <Link
            to={TERMS_PATH}
            className={style.link}
          >
            {I18n.t('Footer_label_terms')}
          </Link>
          <Link
            to={PRIVACY_POLICY_PATH}
            className={style.link}
          >
            {I18n.t('Footer_label_privacy')}
          </Link>
          <Link
            to={WITHDRAWAL_PATH}
            className={style.link}
          >
            {I18n.t('Footer_label_withdrawal')}
          </Link>
          <Link
            to={VERSION_PATH}
            className={style.link}
          >
            {I18n.t('MenuView_button_version')}
          </Link>
        </div>
      </div>
    </footer>
  );
}
